import { tabNames } from '@va/constants';
import { isMobileDevice } from '@va/dashboard/selectors/ui';
import { FiltersContextProvider } from '@va/shared/feature-filters';
import { PageContent, PageHeader, TitleAndContextMenu } from '@va/dashboard/shared/ui-layout';
import { MissingItemErrorView } from '@va/dashboard/ui/pages';
import { useActiveTab } from '@va/dashboard/util-hooks';
import { NavVisitorSegments } from '@va/icons';
import { useTranslate } from '@va/localization';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import CreateEditSection from './CreateEditSection';
import VisitorSegmentsContextProvider from './VisitorSegmentsContext';
import VisitorSegmentsTable from './VisitorSegmentsTable';
import { useSegmentsFilterOptions } from './useSegmentsFilterOptions';

export const VisitorSegments = () => {
  const translate = useTranslate();
  const isMobile = useSelector(isMobileDevice);
  const allFilterOptions = useSegmentsFilterOptions();
  const history = useHistory();

  const onBackClick = useCallback(() => {
    history.goBack();
  }, [history]);

  useActiveTab(tabNames.visitorSegments);

  if (isMobile) {
    return (
      <MissingItemErrorView
        className='mt-12 px-6'
        message={translate('all.visitorSegments.errors.isMobile.title')}
        title={translate('all.visitorSegments.errors.isMobile.message')}
        icon={<NavVisitorSegments className='h-12 w-12' color='#2D2D2D' />}
      />
    );
  }

  return (
    <FiltersContextProvider allFilterOptions={allFilterOptions}>
      <VisitorSegmentsContextProvider>
        <PageHeader
          title={
            <TitleAndContextMenu
              title={translate('all.visitorSegments.title')}
              tooltipTransKey={'tooltipTab.visitorSegments'}
              onBackClick={onBackClick}
            />
          }
          hideDatePicker
          hideFeatureCounter
        />
        <PageContent>
          <div className='flex w-full h-full xl:h-fit flex-col xl:flex-row gap-5 xl:gap-0'>
            <VisitorSegmentsTable />
            <CreateEditSection />
          </div>
        </PageContent>
      </VisitorSegmentsContextProvider>
    </FiltersContextProvider>
  );
};
